import { RouteRecordRaw } from 'vue-router';
import { IRouteConfigAuthMeta } from '@/shared';

const auth: IRouteConfigAuthMeta = {
  required: true,
  permissions: ['superuser'],
};

const devRoutes: RouteRecordRaw[] = (window?.APP_CONFIG?.VUE_APP_ENV === 'development' ? [
  {
    path: '/dev',
    name: 'APIPlayground',
    component: () => import('@/views/_dev/Api.vue'),
    meta: {
      auth,
      title: 'API Playground',
      icon: 'brackets-curly',
      active: false,
    },
  },
  {
    path: '/dev/tiptap',
    name: 'TipTap',
    component: () => import('@/views/_component-demos/TipTap.vue'),
    meta: {
      auth,
      title: 'TipTap',
      icon: 'brackets-curly',
      active: false,
    },
  },
  {
    path: '/dev/FPNPreview',
    name: 'FPNPreview',
    component: () => import('@/views/_component-demos/FPNPreview.vue'),
    meta: {
      auth,
      title: 'FPN Preview',
      icon: 'brackets-curly',
      active: false,
    },
  },
  {
    path: '/dev/sisense-full-dashboard',
    name: 'SisenseFullDashboardDemo',
    component: () => import('@/views/_component-demos/SisenseFullDashboard.vue'),
    meta: {
      auth,
      title: 'Sisense Full Dashboard Demo',
      icon: 'brackets-curly',
      active: false,
      noPagePadding: true,
    },
  },
  {
    path: '/dev/sisense-tabs-dashboard',
    name: 'SisenseTabsDashboard',
    component: () => import('@/views/_component-demos/NavTabsDemo.vue'),
    meta: {
      auth,
      title: 'Sisense Tabs Layout',
      icon: 'brackets-curly',
      active: false,
      noPagePadding: true,
    },
  },
  {
    path: '/dev/NavigationTree',
    name: 'NavigationTree',
    component: () => import('@/views/_component-demos/NavigationTree.vue'),
    meta: {
      auth,
      title: 'Navigation Tree',
      icon: 'brackets-curly',
      active: false,
    },
  },
  {
    path: '/dev/Autoenhance',
    name: 'Autoenhance',
    component: () => import('@/views/_component-demos/Autoenhance.vue'),
    meta: {
      auth,
      title: 'Autoenhance.ai',
      icon: 'brackets-curly',
      active: false,
      noPagePadding: true,
    },
  },
  {
    path: '/dev/RsCascade',
    name: 'RsCascade',
    component: () => import('@/views/_component-demos/RsCascade.vue'),
    meta: {
      auth,
      title: 'Cascade',
      icon: 'brackets-curly',
      active: false,
    },
  },
  {
    path: '/dev/form-components/:name?',
    name: 'FormComponents',
    component: () => import('@/views/_component-demos/form-components/FormComponents.vue'),
    meta: {
      auth,
      title: 'Component Docs',
      icon: 'brackets-curly',
      active: false,
      noPagePadding: true,
    },
  },
  {
    path: '/dev/query-parser',
    name: 'DynamicRouterQueryParser',
    component: () => import('@/views/_dev/DynamicRouterQueryParser.vue'),
    meta: {
      auth,
      title: 'Dynamic Router Query String Parser',
      icon: 'brackets-curly',
      active: false,
    },
  },
  {
    path: '/dev/form-volume-test',
    name: 'FormVolumeTest',
    component: () => import('@/views/_dev/FormVolumeTest.vue'),
    meta: {
      auth,
      title: 'Form Volume Test',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/typed-modules',
    name: 'TypedModules',
    component: () => import('@/views/_dev/TypedStore.vue'),
    meta: {
      auth,
      title: 'Typed Modules',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/email-template',
    name: 'EmailTemplate',
    component: () => import('@/views/_dev/EmailTemplate.vue'),
    meta: {
      auth,
      title: 'Email Template',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/data-table-v2',
    name: 'DataTableV2',
    component: () => import('@/views/_component-demos/DataTableV2.vue'),
    meta: {
      auth,
      title: 'Data Table V2',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/data-table-v2-cell-slots',
    name: 'DataTableV2CellSlots',
    component: () => import('@/views/_component-demos/DataTableV2CellSlot.vue'),
    meta: {
      auth,
      title: 'Data Table V2 Cell Slots',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/promotions-store-example',
    name: 'PromotionsStoreExample',
    component: () => import('@/views/_component-demos/PromotionsStoreExample.vue'),
    meta: {
      auth,
      title: 'Promotions Store & Types Example',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/overlay-scroll-load',
    name: 'OverlayScrollLoad',
    component: () => import('@/views/_component-demos/OverlayScrollLoad.vue'),
    meta: {
      auth,
      title: 'Overlay Scrollbar Scroll Load',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/range-bars',
    name: 'RangeBars',
    component: () => import('@/views/_component-demos/RangeBars.vue'),
    meta: {
      auth,
      title: 'Range Bars',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/reporting',
    name: 'Reporting',
    component: () => import('@/views/_component-demos/ReportingTitleBar.vue'),
    meta: {
      auth,
      title: 'Reporting',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/updated-toasts',
    name: 'UpdatesToasts',
    component: () => import('@/views/_component-demos/UpdatedToasts.vue'),
    meta: {
      auth,
      title: 'Updated Toasts',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/banner',
    name: 'Banner',
    component: () => import('@/views/_component-demos/RsBanner.vue'),
    meta: {
      auth,
      title: 'Banner',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/filter-sidebar',
    name: 'FilterSidebar',
    component: () => import('@/views/_component-demos/FilterSidebar.vue'),
    meta: {
      auth,
      title: 'Filter Sidebar',
      active: false,
      noPagePadding: true,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/listing-sidebar',
    name: 'ListingSidebar',
    component: () => import('@/views/_component-demos/ListingScoreSidebar.vue'),
    meta: {
      auth,
      title: 'Listing Scores Sidebar',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/days-selection',
    name: 'Days Selection',
    component: () => import('@/views/_component-demos/DaysSelection.vue'),
    meta: {
      auth,
      title: 'Days Selection - Tours Feature',
      active: false,
      icon: 'brackets-curly',
      footerBar: {
        enabled: true,
        hasSave: false,
        hasDelete: true,
      },
    },
  },
  {
    path: '/dev/permissions',
    name: 'Permissions',
    component: () => import('@/views/_component-demos/PermissionsComponentDemo.vue'),
    meta: {
      auth,
      title: 'Permissions Component Demo',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/refresh-modal',
    name: 'Refresh Modal',
    component: () => import('@/views/_component-demos/RefreshModal.vue'),
    meta: {
      auth,
      title: 'Refresh Modal - In App Payments Feature',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/buttons-hover-colors-updated',
    name: 'Buttons Hover Colors Updated',
    component: () => import('@/views/_component-demos/ButtonsHoverColorsUpdated.vue'),
    meta: {
      auth,
      title: 'Buttons Hover Colors Updated',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/silent-fails',
    name: 'SilentAPIRequestFailConfigs',
    component: () => import('@/views/_dev/TestSilentFailTimeouts.vue'),
    meta: {
      auth,
      title: 'Silent API Request Fail Configs',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/calendar',
    name: 'Calendar Demo',
    component: () => import('@/views/_component-demos/CalendarDemo.vue'),
    meta: {
      auth,
      title: 'Calendar Demo',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/hubspot-form',
    name: 'RsModalHubspotForm',
    component: () => import('@/views/_component-demos/HubspotFormDemo.vue'),
    meta: {
      auth,
      title: 'RsModalHubspotForm',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/action-table',
    name: 'ActionTableDemo',
    component: () => import('@/views/_component-demos/ActionTableDemo.vue'),
    meta: {
      auth,
      title: 'RsActionTable',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/step-tracker',
    name: 'RsStepTracker',
    component: () => import('@/views/_component-demos/StepTracker.vue'),
    meta: {
      auth,
      title: 'RsStepTracker',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/translations',
    name: 'RsPartialTranslations',
    component: () => import('@/views/_component-demos/Translations.vue'),
    meta: {
      auth,
      title: 'RsPartialTranslations',
      active: false,
      icon: 'brackets-curly',
      footerBar: {
        enabled: true,
        hasTranslationsBtn: () => true,
      },
    },
  },
  {
    path: '/dev/changes-summary-modal',
    name: 'ChangesSummaryModal',
    component: () => import('@/views/_component-demos/ChangesSummaryModal.vue'),
    meta: {
      auth,
      title: 'Change Summary Modal',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/redirect-demo',
    name: 'RsPageRedirectDemo',
    component: () => import('@/views/_component-demos/RsPageRedirectDemo.vue'),
    meta: {
      auth,
      title: 'RsPageRedirectDemo',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/navbar-revamp',
    name: 'Navbar Revamp',
    component: () => import('@/views/_component-demos/NavbarRevamp.vue'),
    meta: {
      auth,
      title: 'Navbar Revamp',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/export-component-demo',
    name: 'Export Component Demo',
    component: () => import('@/views/_component-demos/ExportComponentDemo.vue'),
    meta: {
      auth,
      title: 'Export Component Demo',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/fpn-translations',
    name: 'FPN Tanslations',
    component: () => import('@/views/_component-demos/FPNTranslationsModal.vue'),
    meta: {
      auth,
      title: 'FPN Tanslations',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/product-selection-demo',
    name: 'RsPartialProductSelection Demo',
    component: () => import('@/views/_component-demos/RsPartialProductSelectionDemo.vue'),
    meta: {
      auth,
      title: 'RsPartialProductSelection Demo',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/phone-input',
    name: 'Phone Input',
    component: () => import('@/views/_component-demos/RsPhoneInputDemo.vue'),
    meta: {
      auth,
      title: 'Phone Input',
      active: false,
      icon: 'brackets-curly',
    },
  },
  {
    path: '/dev/styles-guide',
    name: 'StyleGuideDemo',
    component: () => import('@/views/_component-demos/StyleGuideDemo.vue'),
    meta: {
      auth,
      title: 'Styles Guide',
      active: false,
      icon: 'palette',
    },
  },
] : []).sort((a, b) => (a.meta?.title > b.meta?.title ? 1 : -1));

export default devRoutes;
